const commonPath = {
  erp: '/erp',
  crm: '/crm'
};

export default commonPath;
